// Runtime configuration.
//
// In production (Cloud Run) the container regenerates `public/env-config.js` at
// startup from environment variables — which are mapped from Secret Manager —
// and sets `window._env_`. Locally (`npm start`) that file stays empty and we
// fall back to build-time `process.env` (CRA `.env`), then a default.
const runtime: Record<string, string> =
  (typeof window !== "undefined" &&
    (window as unknown as { _env_?: Record<string, string> })._env_) ||
  {};

export function envVar(key: string, fallback = ""): string {
  const v = runtime[key];
  // Guard against an unset env var leaving a literal "${VAR}" placeholder.
  if (v && !v.startsWith("${")) return v;
  return process.env[key] || fallback;
}
